// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__256k4","buttons":"Footer_buttons__u0zs-"};